import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutCliente } from "services/logout";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logoutCliente();
      } finally {
        navigate("/login", { replace: true });
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-slate-500 text-sm">Encerrando sessão...</p>
    </div>
  );
};

export default Logout;
